import { FormField } from '@hqo/react-components-library';

import styled from 'styled-components';

export const StyledFormField = styled(FormField)`
  width: 100%;
  margin-bottom: 24px;
`;
